import React from 'react';
import { withRouter } from 'react-router-dom';

import { componentFamilyAPI } from 'api/requests';

import Header from './Header';
import GeneralInformation from './GeneralInformation';
import NotesSection from './NotesSection';
import ChangeStatus from './ChangeStatus';
import FilePicker from 'Components/FilePicker';
import ApplicationActions from 'Components/ApplicationActions';
import ContactInformation from './ContactInformation';
import ComponentList from './ComponentList'

@withRouter
export default class DetailsApplication extends React.Component {
  _handleBackClick = () => {
    const {user} = this.props;
    user.goBack();
  };

  render() {
    const {
      user,
      match,
      availableActions,
      performFamilyActionFunction,
      changeStatus,
      requestInProcess,
      categories,
    } = this.props;
    const {
      name,
      type,
      components,
      notes,
      testReports,
      status,
      submittedBy,
    } = this.props.familyInfo;
    const {familyId} = match.params;

    if (requestInProcess) {
      return (
        <section className='scene__scene-wrapper'>
          <section className='scene__content-wrapper detailsScene__content-wrapper'>
            <Header user={user} familyId={familyId} loadInProgress={true} />
            <div className='ect-spinner _width_pc_100 _height_120'>
              <div className='ect-spinner__image' />
            </div>
          </section>
        </section>
      );
    } else {
      return (
        <section className='scene__scene-wrapper'>
          <section className={`scene__content-wrapper detailsScene__content-wrapper ${status.toLowerCase()}`}>
            <Header
              status={status}
              familyId={familyId}
              user={user}
              performFamilyActionFunction={performFamilyActionFunction}
              type={type}
            />
            <GeneralInformation
              type={type}
              category={categories ? categories.find(cat => cat.id === type.categoryId) : ''}
              name={name}
            />
            <ComponentList components={components} user={user} />
            <NotesSection notes={notes} />
            <ContactInformation submittedBy={submittedBy} />
            {!!testReports.length && (
              <section className='scene_section'>
                <FilePicker
                  isEditable={false}
                  files={testReports}
                  httpParams={{
                    currentId: familyId,
                    fileIdFieldName: 'id',
                    currentMethod: componentFamilyAPI.downloadReport,
                  }}
                />
              </section>
            )}
            <ChangeStatus
              familyId={familyId}
              availableActions={availableActions}
              performFamilyActionFunction={performFamilyActionFunction}
              changeStatus={changeStatus}
            />
            <ApplicationActions backButtonLabel='Back' backButtonAction={this._handleBackClick} />
          </section>
        </section>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/ComponentManufacturer/ComponentFamily/Details/index.jsx